import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-407acd0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "timeline-wrapper" }
const _hoisted_2 = { class: "timeline" }
const _hoisted_3 = {
  key: 0,
  class: "line"
}
const _hoisted_4 = { class: "timeline" }
const _hoisted_5 = { class: "mobile-step-name" }

import { useBookingStore } from "@/store/bookingStore";
import checkIcon from "@/assets/SVG/checkIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TimeLine',
  setup(__props) {

const bookingStore = useBookingStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bookingStore).ticketBuyPaths, (path, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: `path-${path.path}-${index}-dot`
        }, [
          (index != 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3))
            : _createCommentVNode("", true),
          (!path.valid)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass([
            'dot',
            path.path == _unref(bookingStore).currentBuyPath?.path
              ? 'active'
              : 'disabled',
          ])
              }, null, 2))
            : _createCommentVNode("", true),
          (path.valid)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: _normalizeClass([
            'checkbow-wrapper',
            path.path == _unref(bookingStore).currentBuyPath?.path
              ? 'active'
              : 'disabled',
          ])
              }, [
                _createVNode(checkIcon)
              ], 2))
            : _createCommentVNode("", true)
        ], 64))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bookingStore).ticketBuyPaths, (path, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: `path-${path.path}-${index + 1000}-dot`,
          class: "step-name"
        }, _toDisplayString(path.title), 1))
      }), 128)),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(bookingStore).currentBuyPath?.title), 1)
    ])
  ]))
}
}

})